import http from "./http-common";

class CaseSheetService {
  queryString(payload = {}) {
    return Object.keys(payload)
      .map((key) =>
        key && payload[key] !== undefined && payload[key] !== null && payload[key] !== ""
          ? `${key}=${encodeURIComponent(payload[key])}`
          : ""
      )
      .filter(Boolean)
      .join("&");
  }

  /**
   * GET /patientCaseSheet/list/filter?patientId=1&fromDate=12%2F23%2F2026&toDate=12%2F23%2F2026
   */
  getPatientCaseSheetFilter(params = {}) {
    const qs = this.queryString(params);
    return http.get(`/patientCaseSheet/list/filter?${qs}`);
  }

  /**
   * POST /patientCaseSheet/save
   */
  saveCaseSheet(payload) {
    return http.post("/patientCaseSheet/save", payload);
  }

  /**
   * PUT /patientCaseSheet/update
   */
  updateCaseSheet(payload) {
    return http.put("/patientCaseSheet/update", payload);
  }

  /**
   * GET /patientCaseSheet/:admissionNo
   */
  getCaseSheetByAdmissionNo(admissionNo) {
    return http.get(`/patientCaseSheet/${admissionNo}`);
  }
}

export default new CaseSheetService();
